import { Validator } from '@vista-digital/validator';
import { TabsDisplayType } from '../../../tabs/types/display-type';
export const defaultItemPickerTabsConfig = {
    displayType: TabsDisplayType.Primary
};
export const itemPickerTabsConfigValidator = Validator.object({
    displayType: Validator.oneOf(Object.values(TabsDisplayType))
});
